import { mapKeysToCamelCase, convertAttributesToBoolean } from '@skytech/utils'

import { API_ROUTE_ADMIN_ASSET } from '@/resources/api-routes'
import { get } from '@/util/auth'

import type { AssetTypeOriginal, OwnershipTypeOriginal, ResultStatusOriginal } from './types'
import type { OldAssetOriginal } from './types'

type AssetDownPaymentOriginal = {
  id: number
  amount: number
  currency: string
  date: string
  is_active: 0 | 1
  is_buyout: 0 | 1
  is_off_boarding: 0 | 1
  ecom_order_id?: number
}

type AssetOriginalExtended = {
  comment: string | null
  customer_address_id: number | null
  customer_name: string
  customer_org_no: string
  cost_object_phone_number: string
  user_type_id: number
  ownership_type: OwnershipTypeOriginal
  ownership_id: number
  user_name: string
  policy_id: string | null
  policy_name: string | null
  price_buyout: number | null
  return_status_id: number | null
  result: ResultStatusOriginal | null
  result_cost: number
  delete_certificate: boolean
  delete_certificate_date: string | null
  status_id: number
  type: AssetTypeOriginal
  type_id: number
  ownership_type_id: number
  down_payments: AssetDownPaymentOriginal[]
  device_policy_id?: number
  device_policy_order_cover_amount: number
  device_policy_order_currency: string
  device_policy_order_date: string
  device_policy_order_id?: number
  device_policy_order_remainder_amount: number
  device_policy_order_total_amount: number
  ecom_order_cover_amount: number
  ecom_order_currency: string
  ecom_order_date: string
  ecom_order_id?: number
  ecom_order_remainder_amount: number
  ecom_order_total_amount: number
  is_migrated_into_ecom: 0 | 1
  edited_user_id: number
  editor_user_name: string
  created_user_name: string | null
  cost_object_name: string
  created_date: string
  edited_date: string
  cost_object_type: 'L' | 'M'
  condition_desc: string | null
  numberOfInjuryReports: number
  source: string
  country_id: number
  customer_has_leasing: boolean
  asset_currency: string | null
} & Omit<OldAssetOriginal, 'ownership' | 'asset_type'>

export async function getAsset(id: number) {
  const asset = await get<AssetOriginalExtended>(
    API_ROUTE_ADMIN_ASSET.replace(':assetId', String(id))
  )
  const camelCaseAsset = mapKeysToCamelCase(asset)
  const parsedAsset = convertAttributesToBoolean(camelCaseAsset, 'isMigratedIntoEcom')
  const parsedDownpayments = parsedAsset.downPayments?.map(downpayment =>
    convertAttributesToBoolean(downpayment, ['isActive', 'isBuyout', 'isOffBoarding'])
  )

  return { ...parsedAsset, downPayments: parsedDownpayments }
}
